export default __webpack_public_path__ + "static/media/img2.d1debaa1.png";